import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

export interface AppConfig {
  apiUrl: string;
  wsUrl: string;
  /** SSH-Terminal: separates WS-Backend mit Tailscale-Sidecar (lokal oft ws-dev). Fallback: wsUrl */
  terminalWsUrl?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private config: AppConfig | null = null;
  private loadPromise: Promise<AppConfig> | null = null;

  constructor(private http: HttpClient) {}

  async loadConfig(): Promise<AppConfig> {
    if (this.config) {
      return this.config;
    }

    // Wenn bereits ein Load läuft, warte darauf
    if (this.loadPromise) {
      return this.loadPromise;
    }

    this.loadPromise = (async () => {
      try {
        // Versuche ConfigMap zu laden
        this.config = await firstValueFrom(
          this.http.get<AppConfig>('/assets/config.json')
        );
        console.log('Config loaded from ConfigMap:', this.config);
      } catch (error) {
        console.warn('Could not load config.json, using defaults', error);
        // Fallback für lokale Entwicklung
        this.config = {
          apiUrl: '/api',
          wsUrl: '',
          terminalWsUrl: 'wss://ws-dev.sm-display.displayerize.com',
        };
      }
      return this.config!;
    })();

    return this.loadPromise;
  }

  getConfig(): AppConfig {
    if (!this.config) {
      throw new Error('Config not loaded. Call loadConfig() first.');
    }
    return this.config;
  }

  /** WebSocket-URL für SSH-Terminal (/terminal). Nutzt terminalWsUrl oder wsUrl. */
  getTerminalWsUrl(): string {
    const { terminalWsUrl, wsUrl } = this.getConfig();
    const url = terminalWsUrl?.trim() || wsUrl?.trim() || '';
    if (!url) {
      throw new Error('terminalWsUrl/wsUrl nicht konfiguriert');
    }
    return url;
  }
}
